import "../style-mobile.css";
import { objColorBord } from "./dataHelperCancellation";
const ContentCancellation = ({ arrayCancellationPolicy }) => {
  return (
    <div className="wrapper-cancellation">
      <div className="block-titleCancellation">
        <h1>Правила отмены бронирования</h1>
      </div>
      {arrayCancellationPolicy.map((item, index) => (
        <div key={index} className="block-content-cancellation">
          <div>
            <div
              className="block-border"
              style={{
                borderLeft: `2px solid ${objColorBord[item?.color]}`,
              }}
            />
          </div>
          <p>{item?.content}</p>
        </div>
      ))}
    </div>
  );
};

export default ContentCancellation;
